import gsap from "gsap";
/**
 * Open PDFs in new window
 */
function linksCustomization(){
	var pdfLinks = document.querySelectorAll('a[href$=".pdf"]')

	pdfLinks.forEach(pdf => {
		pdf.setAttribute('target', '_blank');
	});
}

/**
 * Adds smooth scrolling to anchor links
 * 
 * Adds data-scroll-to attribute to anchor links without it.
 */
function scrollTo(){
	// Function to handle smooth scrolling for anchor links
	function smoothScroll(target, offset) {
		const element = document.querySelector(target);
	
		if (element) {
			window.scrollTo({
				top: element.offsetTop - offset,
				behavior: 'smooth'
			});
		}
	}

	// Detect all anchor links on the page without data-scroll-to attribute
	const scrollToLinks = document.querySelectorAll('a[href^="#"]:not([data-scroll]):not([class^="magnific-"])')
	scrollToLinks.forEach(link => {
		link.setAttribute('data-scroll', 'scroll-to');
	});

	
	// Event listener for anchor links
	let anchorLinks = document.querySelectorAll( '[data-scroll=scroll-to]' )

	anchorLinks.forEach(element => {
		element.addEventListener('click', function(event) {
			const target = event.target;
		
			event.preventDefault(); // Prevent default anchor link behavior
		
			let offset = 50; // Adjust this value to set the desired offset
			if ( target.getAttribute('data-scroll-space') ){
				offset = target.getAttribute('data-scroll-space')
			}
			smoothScroll(target.getAttribute('href'), offset); // Smooth scroll to the target element with an offset
		});
	});
}

/**
 * Adds a class to tablepress tables to make them responsive.
 */
function responsiveTables(){
	if ( document.querySelectorAll('.tablepress').length > 0 ) {
		const tables = document.querySelectorAll('.main.main .prose table');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			
			// Insert the wrapper before the toWrap element
			toWrap.parentNode.insertBefore(wrapper, toWrap);
			
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	}
}

// Add span to buttons so hover button works
function buttonSpans() {	
	if ( document.querySelectorAll('.button').length > 0 ) {
		const buttons = document.querySelectorAll('.button');
		function wrapInner(parent, wrapper) {
			if (typeof wrapper === "string") {
				wrapper = document.createElement(wrapper);
			}
			var div = parent.appendChild(wrapper)					  
		
			while (parent.firstChild !== wrapper) {
				   wrapper.appendChild(parent.firstChild);
			  }
		}
		[...buttons].forEach((button) => {			
			wrapInner(button, 'span', '', '');
		});
	}
}

function copyLink() {
	var copyLinkButton = document.querySelector('[data-target=copy-link]');		
	var tooltip =  document.querySelector('[data-target=copy-link-tooltip]');		
	if(copyLinkButton) {
		var tooltipTL = gsap.timeline();
			tooltipTL.to(tooltip, {
				opacity: 1,
				y: "-55px",
				duration: 0.2
			})
			tooltipTL.to(tooltip, {
				opacity: 0,
				duration: 0.2
			}, ">+=2")
		tooltipTL.pause();			
		copyLinkButton.addEventListener('click', (e) => {				
			tooltipTL.pause(0);
			e.preventDefault();
			navigator.clipboard.writeText(					 
				window.location.href					
			)
			tooltipTL.play();
			

				
		})
	}
}

function cookieYesSnippet() {
	document.addEventListener("cookieyes_consent_update", function (eventData) {
		const data = eventData.detail;
		if (data.accepted.includes("analytics")) {
			window.clarity('consent');
		   
		} else {
			window.clarity('consent', false);
			   
		}
	  });
	 document.addEventListener("cookieyes_banner_load", function (eventData) {
		const data = eventData.detail;
	   if (data.categories.analytics) {
			window.clarity('consent');
				   
		} else {
			window.clarity('consent', false);
				   
		}
	  });
}

export { linksCustomization, scrollTo, responsiveTables, buttonSpans, copyLink, cookieYesSnippet }